'use client';

import { DropdownMenu } from '@common/components';
import { SvgArrowdownFill } from '@common/icon';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import {
  DEFAULT_SEARCH_CATEGORY,
  SEARCH_CATEGORY_GROUPS,
  SEARCH_CATEGORY_ITEMS,
  SEARCH_CATEGORY_QUERY_KEY,
} from './search-categories';

export function SearchCategoryDropdown() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const currentValue =
    searchParams?.get(SEARCH_CATEGORY_QUERY_KEY) ?? DEFAULT_SEARCH_CATEGORY;
  const currentLabel =
    SEARCH_CATEGORY_ITEMS.find((item) => item.value === currentValue)?.label ??
    '정책';

  const handleChange = (value: string) => {
    const params = new URLSearchParams();
    const keyword = searchParams?.get('q');

    if (keyword) params.set('q', keyword);
    if (value !== DEFAULT_SEARCH_CATEGORY) {
      params.set(SEARCH_CATEGORY_QUERY_KEY, value);
    }

    const query = params.toString();
    router.replace(`${pathname}${query ? `?${query}` : ''}`, { scroll: false });
  };

  return (
    <DropdownMenu<string, false, 'custom'>
      type="custom"
      className="mobile-tablet:w-auto mobile-tablet:min-w-80 mobile-tablet:max-w-100"
      groups={SEARCH_CATEGORY_GROUPS}
      value={currentValue}
      onChange={handleChange}
    >
      <div className="flex min-w-0 items-center gap-4 rounded-pill px-12 py-4 mobile-tablet:px-8">
        <span className="whitespace-nowrap font-500 text-Gray-900 typo-body3 mobile-tablet:min-w-0 mobile-tablet:truncate mobile-tablet:font-400 mobile-tablet:tracking-[-0.28px] mobile-tablet:text-Gray-700 mobile-tablet:typo-body4">
          {currentLabel}
        </span>
        <SvgArrowdownFill className="size-16 shrink-0 text-Gray-900 mobile-tablet:text-Gray-700" />
      </div>
    </DropdownMenu>
  );
}
